import Link from "next/link";
import { useRouter } from "next/router";
import React from "react";
import { useTranslation } from "next-i18next";
import { ArrowLeft, ArrowRight } from "../../assets";

export default function Pagination({ pageCount, filters, link }) {
	const router = useRouter();
	const { page: pageIndex } = router.query;
	const pageCountArray = [];
	for (let i = 0; i < pageCount; i++) {
		pageCountArray.push(i + 1);
	}
	const firstPage = pageCountArray[0];
	const totalPages = pageCountArray[pageCountArray.length - 1];
	const currentPageIndex = Number(pageIndex);
	const { t } = useTranslation();

	return (
		<div className="pagination_container">
			<Link
				href={`${link}?page=${currentPageIndex - 1}${
					filters ? `&${filters}` : ""
				}`}
			>
				<ArrowLeft />
				<span>{t("button.pagination.previous")}</span>
			</Link>
			<ul>
				{currentPageIndex > firstPage ? (
					<li>
						<Link
							style={
								parseInt(currentPageIndex) === firstPage
									? { backgroundColor: "#164230", color: "#FFFFFF" }
									: { backgroundColor: "#f6faf7", color: "#164230" }
							}
							className="pagination_link"
							href={`${link}?page=${firstPage}${filters ? `&${filters}` : ""}`}
						>
							{firstPage}
						</Link>
					</li>
				) : null}
				<li>
					<Link
						style={
							parseInt(currentPageIndex)
								? { backgroundColor: "#164230", color: "#FFFFFF" }
								: { backgroundColor: "#f6faf7", color: "#164230" }
						}
						className="pagination_link"
						href={`${link}?page=${currentPageIndex}${
							filters ? `&${filters}` : ""
						}`}
					>
						{currentPageIndex}
					</Link>
				</li>
				{totalPages >= 2 &&
				currentPageIndex < totalPages &&
				currentPageIndex + 1 !== totalPages ? (
					<li aria-label="current-1">
						<Link
							style={
								parseInt(currentPageIndex) === pageIndex
									? { backgroundColor: "#164230", color: "#FFFFFF" }
									: { backgroundColor: "#f6faf7", color: "#164230" }
							}
							className="pagination_link"
							href={`${link}?page=${currentPageIndex + 1}${
								filters ? `&${filters}` : ""
							}`}
						>
							{currentPageIndex + 1}
						</Link>
					</li>
				) : null}
				{totalPages >= 3 &&
				currentPageIndex <= totalPages &&
				currentPageIndex + 2 !== totalPages &&
				currentPageIndex + 2 < totalPages &&
				currentPageIndex + 1 !== totalPages &&
				currentPageIndex + 2 < totalPages ? (
					<li aria-label="current-2">
						<Link
							style={
								parseInt(currentPageIndex) === pageIndex
									? { backgroundColor: "#164230", color: "#FFFFFF" }
									: { backgroundColor: "#f6faf7", color: "#164230" }
							}
							className="pagination_link"
							href={`${link}?page=${currentPageIndex + 2}${
								filters ? `&${filters}` : ""
							}`}
						>
							{currentPageIndex + 2}
						</Link>
					</li>
				) : null}
				{currentPageIndex !== totalPages ? (
					<li aria-label="total-pages">
						<Link
							style={
								parseInt(currentPageIndex) === pageIndex
									? { backgroundColor: "#164230", color: "#FFFFFF" }
									: { backgroundColor: "#f6faf7", color: "#164230" }
							}
							className="pagination_link"
							href={`${link}?page=${totalPages}${filters ? `&${filters}` : ""}`}
						>
							{totalPages}
						</Link>
					</li>
				) : null}
			</ul>
			<Link
				href={`${link}?page=${currentPageIndex + 1}${
					filters ? `&${filters}` : ""
				}`}
			>
				<span>{t("button.pagination.next")}</span>
				<ArrowRight />
			</Link>
		</div>
	);
}
